export function getView(treatment_plans, show_financials_managed_externally) {
  if (treatment_plans.length > 1) {
    return 'Selection'
  } else {
    return show_financials_managed_externally
      ? 'FinancialsManagedExternally'
      : 'Normal'
  }
}
